import React, { useEffect, useMemo, useState } from 'react';

import BannerPopup from './Banner';
import StandardPopup from './Standard';

import './styles.css';

function Popup({ popup, closeModal, ...rest }) {
  const [show, setShow] = useState(false);

  const type = popup?.type ?? 'standard';
  const animation = useMemo(
    () => `${type}-` + (popup?.animation ? popup.animation : 'none'),
    [popup]
  );
  const showing = useMemo(() => !!popup && show, [popup, show]);

  const PopupComponent = useMemo(() => {
    const props = {
      ...rest,
      popup: popup,
      closeModal: () => setShow(false),
      showing: showing,
      animation: animation
    };
    return type === 'banner' ? (
      <BannerPopup {...props} />
    ) : (
      <StandardPopup {...props} />
    );
  }, [type, showing, animation, popup]);

  useEffect(() => {
    const trigger = popup?.triggers?.[0];

    if (popup && trigger && trigger.delay > 0) {
      setTimeout(() => setShow(true), trigger.delay);
    } else if (popup) {
      setShow(true);
    } else {
      setShow(false);
    }
    return () => {
      setShow(false);
    };
  }, [popup]);

  return <div>{popup && PopupComponent}</div>;
}

export default Popup;
